import { CommonComponentsProvider } from '@telia-common-components/shared';
import React from 'react';
import { Go3AppDetailsContent } from './Go3AppDetailsContent';
import { Go3AppDetailsProvider } from './Go3AppDetailsProvider';
const Go3AppDetails = (props) => {
    const { tier, app, language, isTestEnvironment, disableTranslationsStatistics, translations } = props;
    return (React.createElement(CommonComponentsProvider, { app: app, tier: tier, language: language, translations: translations, isTestEnvironment: isTestEnvironment, disableTranslationsStatistics: disableTranslationsStatistics },
        React.createElement(Go3AppDetailsProvider, { ...props },
            React.createElement(Go3AppDetailsContent, { lang: language }))));
};
export { Go3AppDetails };
